module.exports = __webpack_public_path__ + "static/media/block_icon_video.3d1610c7.svg";